var $ = require('../internals/export');
var bind = require('../internals/function-bind');

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
  bind: bind
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.function.bind.js
// module id = 719
// module chunks = 49